(() => {
  'use strict';
  const PRODUCT_HANDLE = 'vipcoo-h3-electric-dirt-bikes';
  const PRODUCT_URL = 'https://vipcoo.eu/de/products/vipcoo-h3-electric-dirt-bikes?variant=48816374644985';
  const FALLBACK_VARIANT_ID = 48816374644985;
  const FALLBACK = { id: FALLBACK_VARIANT_ID, price: 129900, compare_at_price: 219900 };
  let firstVariant = FALLBACK;

  const track = (name, detail = {}) => {
    const eventName = `vp_lp_${name}`;
    if (typeof window.gtag === 'function') window.gtag('event', eventName, detail);
    else if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: eventName, ...detail });
    if (typeof window.fbq === 'function') window.fbq('trackCustom', eventName, detail);
  };
  const money = cents => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(cents / 100);
  const renderPrice = variant => {
    document.querySelectorAll('[data-live-price]').forEach(el => { el.textContent = money(variant.price); });
    document.querySelectorAll('[data-compare-price]').forEach(el => {
      const show = variant.compare_at_price && variant.compare_at_price > variant.price;
      el.hidden = !show;
      if (show) el.textContent = money(variant.compare_at_price);
    });
    const upgraded = variant.price + 59900;
    document.querySelectorAll('[data-upgrade-total]').forEach(el => { el.textContent = money(upgraded); });
    document.querySelectorAll('[data-upgrade-saving]').forEach(el => { el.textContent = `${money(Math.max(0, 219900 - upgraded))} ERSPARNIS`; });
  };
  const base = location.hostname.endsWith('vipcoo.eu') ? (window.Shopify?.routes?.root || '/') : 'https://vipcoo.eu/';
  fetch(`${base}products/${PRODUCT_HANDLE}.js`, { headers: { Accept: 'application/json' } })
    .then(r => r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`)))
    .then(product => {
      if (!product.variants?.length) throw new Error('Keine Variante');
      firstVariant = product.variants[0]; renderPrice(firstVariant);
      track('price_loaded', { variant_id: String(firstVariant.id), value: firstVariant.price / 100, currency: 'EUR' });
    }).catch(() => renderPrice(FALLBACK));

  document.querySelectorAll('[data-buy-now]').forEach(link => link.addEventListener('click', () => {
    track('product_page_click', { variant_id: String(firstVariant.id || ''), value: firstVariant.price / 100, currency: 'EUR' });
  }));

  const modal = document.getElementById('video-player');
  const frame = modal?.querySelector('iframe');
  const close = () => {
    if (!modal || !frame) return;
    modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); frame.src = ''; document.body.style.overflow = '';
  };
  document.querySelectorAll('[data-video-id]').forEach(button => button.addEventListener('click', () => {
    if (!modal || !frame) return;
    const id = button.dataset.videoId;
    const origin = /^https?:$/.test(location.protocol) ? location.origin : 'https://vipcoo.eu';
    const referrer = /^https?:$/.test(location.protocol) ? location.href : 'https://vipcoo.eu/';
    const params = new URLSearchParams({ autoplay: '1', playsinline: '1', rel: '0', enablejsapi: '1', origin, widget_referrer: referrer });
    if (button.dataset.videoStart) params.set('start', button.dataset.videoStart);
    frame.src = `https://www.youtube.com/embed/${id}?${params}`;
    modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
    track('video_play', { video_id: id, video_title: button.getAttribute('aria-label') || '' });
  }));
  modal?.querySelector('.video-close')?.addEventListener('click', close);
  modal?.addEventListener('click', event => { if (event.target === modal) close(); });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') close(); });
})();
